// @ts-nocheck
import React, { useState } from "react";

/**
 * Menu photo with a graceful placeholder.
 *
 * Items in src/data/menu.js ship without photos, and a broken <img> looks like a bug.
 * Until real photos are added (either an imageUrl in the static file or from the DB)
 * this renders a soft tile with the item's icon instead.
 */
const MenuImage = ({ src, alt, className = "", icon = "🐟", onClick }) => {
    const [failed, setFailed] = useState(false);

    if (!src || failed) {
        return (
            <div
                onClick={onClick}
                className={`flex items-center justify-center bg-gradient-to-br from-sky-50 via-white to-cyan-50 ${className}`}
            >
                <span className="text-4xl opacity-40 select-none" role="img" aria-label={alt}>
                    {icon}
                </span>
            </div>
        );
    }

    return (
        <img
            src={src}
            alt={alt}
            className={className}
            onClick={onClick}
            onError={() => setFailed(true)}
            loading="lazy"
        />
    );
};

export default MenuImage;
